/* PasswordInput.js */
/* @author: anghello */

// TODO

import { useState, forwardRef } from 'react';
import { InputGroup, InputGroupText } from 'reactstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './passwordinput.scss';

const PasswordInput = forwardRef(({ ...rest }, ref) => {
  const [passwordType, setPasswordType] = useState('password');
  const togglePasswordVisibility = () => {
    setPasswordType((prevType) => prevType === 'password' ? 'text' : 'password');
  };

  return (
    <InputGroup className='passwordinput1'>
      <input
        ref={ref}
        type={passwordType}
        {...rest}
      />
      <InputGroupText onClick={togglePasswordVisibility} className='inputgrouptext'>
        {passwordType === 'password' ? <FaEye /> : <FaEyeSlash />}
      </InputGroupText>
    </InputGroup>
  );
});

export default PasswordInput;